import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import './App.css';
import Retrieve from './components/retrieve';
import 'antd/dist/antd.css';
import '@fortawesome/fontawesome-free/css/all.css';
import SearchPage from './components/search/search';
import VC from './components/vc'

function App() {
  return (
      <Router>
        <div className="App">
          <Route exact path='/' render={props => <SearchPage {...props} title="学术合作"/>}/>
          <Route exact path='/vc' render={props => <VC {...props} title="VC 专家推荐" />} />
          <Route exact path='/auth/retrieve' ><Retrieve /></Route>
          <Route exact path='/auth/reset-password' ><Retrieve /></Route>
        </div>
      </Router>
  );
}

export default App;
